/* eslint-disable no-plusplus */
/* eslint-disable no-case-declarations */
/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';

import _ from 'underscore';
import arrayInject from 'services/array_inject';
import { emptyBidding, emptyFollowup } from 'services/mock_bulletin';
import { BulletinsTypes, BulletinsState, CommentsRequestState } from './types';

const INITIAL_STATE: BulletinsState = {
  request: {
    fetch_bulletin_content: {
      loading: false,
      loaded: false,
      error: false,
    },
    fetch_bulletin_content_by_id: {
      loading: false,
      loaded: false,
      error: false,
    },
    fetch_bulletin_filters: {
      loading: false,
      loaded: false,
      error: false,
    },
    fetch_bulletin_biddings: {},
    fetch_bulletin_followups: {},
    create_bidding_favorite_bulletin: {
      loading: false,
      loaded: false,
      error: false,
    },
    destroy_bidding_favorite_bulletin: {
      loading: false,
      loaded: false,
      error: false,
    },
    destroy_bidding_managed_bulletin: {
      loading: false,
      loaded: false,
      error: false,
    },
    create_viewed_bidding_bulletin: {
      loading: false,
      loaded: false,
      error: false,
    },
    destroy_viewed_bidding_bulletin: {
      loading: false,
      loaded: false,
      error: false,
    },
    mark_all_bulletins_read: {
      loading: false,
      loaded: false,
      error: false,
    },
    overview: {
      loading: false,
      loaded: false,
      error: false,
    },
    ia_chat: {
      loading: false,
      loaded: false,
      error: false,
    },
  },
  comments_request: {},
  bulletins: {
    filter_bulletins: [],
    bulletins_biddings_list: {},
    bulletins_followups_list: {},
    total: 0,
    by_region: {},
    by_esfera: {},
    by_modality: [],
    by_situation: [],
    by_portal: [],
    ia_chat_messages: [
      {
        role: 'assistant',
        content:
          '<p>Descreva o que sua empresa busca e eu criarei seu filtro de licitações.</p><p class="mb-0">Exemplo: objeto, região e/ou órgão público.</p>',
      },
    ],
    ia_chat_tool_action: null,
    ia_applied_filter: null,
    status_filter: [],
    match_only_filter: false,
  },
};

const INITIAL_STATE_COMMENT: CommentsRequestState = {
  get_comments_bulletin: {
    loading: false,
    loaded: false,
    error: false,
  },
  create_comment_bulletin: {
    loading: false,
    loaded: false,
    error: false,
  },
  destroy_comment_bulletin: {
    loading: false,
    loaded: false,
    error: false,
  },
};

const reducer: Reducer<BulletinsState> = (
  state = INITIAL_STATE,
  {
    type,
    result,
    bulletin_id,
    filter_id,
    current_page,
    bidding_id,
    contact_name,
    contact_client_id,
    comment_id,
    per_page,
    passive_load,
    isSearch,
    content,
    status_filter,
    match_only_filter,
    messages,
    iaAppliedFilter,
  },
) => {
  return produce(state, (draft) => {
    switch (type) {
      case BulletinsTypes.FETCH_BULLETINS_REQUEST:
        draft.request.fetch_bulletin_filters = {
          ...INITIAL_STATE.request.fetch_bulletin_filters,
          loading: true,
        };
        break;

      case BulletinsTypes.FETCH_BULLETINS_SUCCESS:
        if (!result?.data?.data) draft.bulletins.filter_bulletins = result?.data;
        else draft.bulletins.filter_bulletins = [];

        draft.request.fetch_bulletin_filters = {
          ...INITIAL_STATE.request.fetch_bulletin_filters,
          loaded: true,
        };
        break;

      case BulletinsTypes.FETCH_BULLETINS_FAILURE:
        draft.request.fetch_bulletin_filters = {
          ...INITIAL_STATE.request.fetch_bulletin_filters,
          error: true,
        };
        break;

      case BulletinsTypes.FETCH_BULLETINS_REPRESENTED_REQUEST:
        draft.request.fetch_bulletin_filters = {
          ...INITIAL_STATE.request.fetch_bulletin_filters,
          loading: true,
        };
        break;

      case BulletinsTypes.FETCH_BULLETINS_REPRESENTED_SUCCESS:
        if (!result?.data?.data) draft.bulletins.filter_bulletins = result?.data;
        else draft.bulletins.filter_bulletins = [];

        draft.request.fetch_bulletin_filters = {
          ...INITIAL_STATE.request.fetch_bulletin_filters,
          loaded: true,
        };
        break;

      case BulletinsTypes.FETCH_BULLETINS_REPRESENTED_FAILURE:
        draft.request.fetch_bulletin_filters = {
          ...INITIAL_STATE.request.fetch_bulletin_filters,
          error: true,
        };
        break;

      case BulletinsTypes.SET_BULLETIN_READ:
        const updatedFilterIndex = state.bulletins.filter_bulletins.findIndex(
          (filter_bulletin) => filter_bulletin.filter.id === filter_id,
        );
        const updatedBulletinFilterIndex = state.bulletins.filter_bulletins[
          updatedFilterIndex
        ].bulletin_filters.findIndex(
          (bulletin_filter) => bulletin_filter.bulletin_id.toString() === bulletin_id,
        );
        draft.bulletins.filter_bulletins[updatedFilterIndex].bulletin_filters[
          updatedBulletinFilterIndex
        ].read = true;
        break;

      case BulletinsTypes.FETCH_BULLETIN_BIDDINGS_REQUEST:
        draft.request.fetch_bulletin_biddings[`bulletin_${bulletin_id}_page_${current_page}`] = {
          loaded: false,
          error: false,
          loading: true,
        };
        break;

      case BulletinsTypes.FETCH_BULLETIN_BIDDINGS_SUCCESS:
        const firstList = [];
        if (!draft.bulletins.bulletins_biddings_list[bulletin_id]) {
          for (let index = 0; index < result?.data?.total_entries; index++) {
            firstList.push(emptyBidding());
          }
          draft.bulletins.bulletins_biddings_list[bulletin_id] = {
            biddings: firstList,
            current_page: passive_load
              ? state.bulletins.bulletins_biddings_list[bulletin_id].current_page
              : current_page,
            total_entries: result?.data?.total_entries,
            total_pages: result?.data?.total_pages,
            biddings_ids: result?.data?.biddings_ids,
          };
        }

        const newBiddings = isSearch
          ? result?.data?.biddings
          : arrayInject(
              state.bulletins.bulletins_biddings_list[bulletin_id]?.biddings || firstList,
              result?.data?.biddings,
              (current_page - 1) * per_page,
            );

        draft.bulletins.bulletins_biddings_list[bulletin_id] = {
          biddings: newBiddings,
          current_page: passive_load
            ? state.bulletins.bulletins_biddings_list[bulletin_id].current_page
            : current_page,
          total_entries: result?.data?.total_entries,
          total_pages: result?.data?.total_pages,
          biddings_ids: result?.data?.biddings_ids,
          match_enabled: result?.data?.match_enabled,
          match_resumo: result?.data?.match_resumo,
        };

        draft.request.fetch_bulletin_biddings[`bulletin_${bulletin_id}_page_${current_page}`] = {
          loading: false,
          error: false,
          loaded: true,
        };
        break;

      case BulletinsTypes.FETCH_BULLETIN_BIDDINGS_FAILURE:
        draft.request.fetch_bulletin_biddings[`bulletin_${bulletin_id}_page_${current_page}`] = {
          loaded: false,
          loading: false,
          error: true,
        };
        break;

      case BulletinsTypes.CREATE_BIDDING_FAVORITE_REQUEST:
        draft.request.create_bidding_favorite_bulletin = {
          ...INITIAL_STATE.request.create_bidding_favorite_bulletin,
          loading: true,
        };
        break;

      case BulletinsTypes.CREATE_BIDDING_FAVORITE_SUCCESS:
        draft.request.create_bidding_favorite_bulletin = {
          ...INITIAL_STATE.request.create_bidding_favorite_bulletin,
          loaded: true,
        };
        const createFavoriteBiddingIndex = state.bulletins.bulletins_biddings_list[
          bulletin_id
        ].biddings.findIndex((bidding) => Number(bidding.bidding_id) === Number(bidding_id));

        draft.bulletins.bulletins_biddings_list[bulletin_id].biddings[
          createFavoriteBiddingIndex
        ].favorited = true;
        draft.bulletins.bulletins_biddings_list[bulletin_id].biddings[
          createFavoriteBiddingIndex
        ].favorited_by = _.uniq([
          ...state.bulletins.bulletins_biddings_list[bulletin_id].biddings[
            createFavoriteBiddingIndex
          ].favorited_by,
          contact_name,
        ]);
        break;

      case BulletinsTypes.CREATE_BIDDING_FAVORITE_FAILURE:
        draft.request.create_bidding_favorite_bulletin = {
          ...INITIAL_STATE.request.create_bidding_favorite_bulletin,
          error: true,
        };
        break;

      case BulletinsTypes.DESTROY_BIDDING_FAVORITE_REQUEST:
        draft.request.destroy_bidding_favorite_bulletin = {
          ...INITIAL_STATE.request.destroy_bidding_favorite_bulletin,
          loading: true,
        };
        break;

      case BulletinsTypes.DESTROY_BIDDING_FAVORITE_SUCCESS:
        draft.request.destroy_bidding_favorite_bulletin = {
          ...INITIAL_STATE.request.destroy_bidding_favorite_bulletin,
          loaded: true,
        };
        const destroyFavoriteBiddingIndex = state.bulletins.bulletins_biddings_list[
          bulletin_id
        ].biddings.findIndex((bidding) => Number(bidding.bidding_id) === Number(bidding_id));

        draft.bulletins.bulletins_biddings_list[bulletin_id].biddings[
          destroyFavoriteBiddingIndex
        ].favorited = false;
        draft.bulletins.bulletins_biddings_list[bulletin_id].biddings[
          destroyFavoriteBiddingIndex
        ].favorited_by = state.bulletins.bulletins_biddings_list[bulletin_id].biddings[
          destroyFavoriteBiddingIndex
        ].favorited_by.filter((contacts) => contacts !== contact_name);
        break;

      case BulletinsTypes.DESTROY_BIDDING_FAVORITE_FAILURE:
        draft.request.destroy_bidding_favorite_bulletin = {
          ...INITIAL_STATE.request.destroy_bidding_favorite_bulletin,
          error: true,
        };
        break;

      case BulletinsTypes.CREATE_COMMENT_REQUEST:
        draft.comments_request[bidding_id] = {
          ...INITIAL_STATE_COMMENT,
          create_comment_bulletin: {
            ...INITIAL_STATE_COMMENT.create_comment_bulletin,
            loading: true,
          },
        };
        break;

      case BulletinsTypes.CREATE_COMMENT_SUCCESS:
        draft.comments_request[bidding_id] = {
          ...INITIAL_STATE_COMMENT,
          create_comment_bulletin: {
            ...INITIAL_STATE_COMMENT.create_comment_bulletin,
            loaded: true,
          },
        };

        const comment = {
          contact_client: {
            id: result?.data?.contact_client_id,
            nome: contact_name,
          },
          id: result?.data.id,
          message: result?.data.message,
          created_at: result?.data.created_at,
        };

        const createCommentsBiddingIndex = state.bulletins.bulletins_biddings_list[
          bulletin_id
        ].biddings.findIndex((bidding) => Number(bidding.bidding_id) === Number(bidding_id));

        draft.bulletins.bulletins_biddings_list[bulletin_id].biddings[
          createCommentsBiddingIndex
        ].client_comments = [
          ...state.bulletins.bulletins_biddings_list[bulletin_id].biddings[
            createCommentsBiddingIndex
          ].client_comments,
          comment,
        ];
        break;

      case BulletinsTypes.CREATE_COMMENT_FAILURE:
        draft.comments_request[bidding_id] = {
          ...INITIAL_STATE_COMMENT,
          create_comment_bulletin: {
            ...INITIAL_STATE_COMMENT.create_comment_bulletin,
            error: true,
          },
        };
        break;

      case BulletinsTypes.DESTROY_COMMENT_REQUEST:
        draft.comments_request[bidding_id] = {
          ...INITIAL_STATE_COMMENT,
          destroy_comment_bulletin: {
            ...INITIAL_STATE_COMMENT.destroy_comment_bulletin,
            loading: true,
          },
        };
        break;

      case BulletinsTypes.DESTROY_COMMENT_SUCCESS:
        draft.comments_request[bidding_id] = {
          ...INITIAL_STATE_COMMENT,
          destroy_comment_bulletin: {
            ...INITIAL_STATE_COMMENT.destroy_comment_bulletin,
            loaded: true,
          },
        };

        const destroyCommentsBiddingIndex = state.bulletins.bulletins_biddings_list[
          bulletin_id
        ].biddings.findIndex((bidding) => Number(bidding.bidding_id) === Number(bidding_id));

        draft.bulletins.bulletins_biddings_list[bulletin_id].biddings[
          destroyCommentsBiddingIndex
        ].client_comments = [
          ...draft.bulletins.bulletins_biddings_list[bulletin_id].biddings[
            destroyCommentsBiddingIndex
          ].client_comments.filter((comment) => comment.id !== comment_id),
        ];

        break;

      case BulletinsTypes.DESTROY_COMMENT_FAILURE:
        draft.comments_request[bidding_id] = {
          ...INITIAL_STATE_COMMENT,
          destroy_comment_bulletin: {
            ...INITIAL_STATE_COMMENT.destroy_comment_bulletin,
            error: true,
          },
        };
        break;

      case BulletinsTypes.CREATE_MANAGED_SUCCESS:
        const createManagedBiddingIndex = state.bulletins.bulletins_biddings_list[
          bulletin_id
        ].biddings.findIndex((bidding) => Number(bidding.bidding_id) === Number(bidding_id));

        draft.bulletins.bulletins_biddings_list[bulletin_id].biddings[
          createManagedBiddingIndex
        ].managed = true;
        draft.bulletins.bulletins_biddings_list[bulletin_id].biddings[
          createManagedBiddingIndex
        ].managers = result.data.managed.managers;

        break;

      case BulletinsTypes.DESTROY_MANAGED_REQUEST:
        draft.request.destroy_bidding_managed_bulletin = {
          ...INITIAL_STATE.request.destroy_bidding_managed_bulletin,
          loading: true,
        };
        break;

      case BulletinsTypes.DESTROY_MANAGED_SUCCESS:
        const destroyManagedBiddingIndex = state.bulletins.bulletins_biddings_list[
          bulletin_id
        ].biddings.findIndex((bidding) => Number(bidding.bidding_id) === Number(bidding_id));

        const bidding =
          draft.bulletins.bulletins_biddings_list[bulletin_id].biddings[destroyManagedBiddingIndex];

        bidding.managers = bidding.managers.filter(
          (manager) => manager.user_id !== contact_client_id,
        );

        if (bidding.managers.length > 0) {
          bidding.managed = false;
        } else {
          draft.bulletins.bulletins_biddings_list[bulletin_id].biddings[
            destroyManagedBiddingIndex
          ].managed = false;
          draft.bulletins.bulletins_biddings_list[bulletin_id].biddings[
            destroyManagedBiddingIndex
          ].managers = bidding.managers;
        }

        draft.request.destroy_bidding_managed_bulletin = {
          ...INITIAL_STATE.request.destroy_bidding_managed_bulletin,
          loaded: true,
        };
        break;

      case BulletinsTypes.DESTROY_MANAGED_FAILURE:
        draft.request.destroy_bidding_managed_bulletin = {
          ...INITIAL_STATE.request.destroy_bidding_managed_bulletin,
          error: true,
        };
        break;

      case BulletinsTypes.UPDATE_CURRENT_PAGE_BIDDINGS:
        if (!draft.bulletins.bulletins_biddings_list[bulletin_id]) return;

        draft.bulletins.bulletins_biddings_list[bulletin_id].current_page = current_page;
        break;

      case BulletinsTypes.UPDATE_CURRENT_PAGE_FOLLOWUPS:
        if (!draft.bulletins.bulletins_followups_list[bulletin_id]) return;

        draft.bulletins.bulletins_followups_list[bulletin_id].current_page = current_page;
        break;

      case BulletinsTypes.CLEAR:
        draft.bulletins.bulletins_followups_list = INITIAL_STATE.bulletins.bulletins_followups_list;
        draft.bulletins.bulletins_biddings_list = INITIAL_STATE.bulletins.bulletins_biddings_list;
        draft.request = INITIAL_STATE.request;
        break;

      case BulletinsTypes.FETCH_BULLETIN_FOLLOWUPS_REQUEST:
        draft.request.fetch_bulletin_followups[`bulletin_${bulletin_id}_page_${current_page}`] = {
          loaded: false,
          error: false,
          loading: true,
        };
        break;

      case BulletinsTypes.FETCH_BULLETIN_FOLLOWUPS_SUCCESS:
        const firstListFollowups = [];

        if (!draft.bulletins.bulletins_followups_list[bulletin_id]) {
          for (let index = 0; index < result?.data?.total_entries; index++) {
            firstListFollowups.push(emptyFollowup());
          }
          draft.bulletins.bulletins_followups_list[bulletin_id] = {
            followups: firstListFollowups,
            current_page: passive_load
              ? state.bulletins.bulletins_followups_list[bulletin_id].current_page
              : current_page,
            total_entries: result?.data?.total_entries,
            total_pages: result?.data?.total_pages,
            followups_ids: result?.data?.followups_ids,
          };
        }

        const newFollowups = isSearch
          ? result?.data?.followups
          : arrayInject(
              state.bulletins.bulletins_followups_list[bulletin_id]?.followups ||
                firstListFollowups,
              result?.data?.followups,
              (current_page - 1) * per_page,
            );

        draft.bulletins.bulletins_followups_list[bulletin_id] = {
          followups: newFollowups,
          current_page: passive_load
            ? state.bulletins.bulletins_followups_list[bulletin_id].current_page
            : current_page,
          total_entries: result?.data.total_entries,
          total_pages: result?.data.total_pages,
          followups_ids: result?.data.followups_ids,
        };
        draft.request.fetch_bulletin_followups[`bulletin_${bulletin_id}_page_${current_page}`] = {
          loading: false,
          error: false,
          loaded: true,
        };
        break;

      case BulletinsTypes.FETCH_BULLETIN_FOLLOWUPS_FAILURE:
        draft.request.fetch_bulletin_followups[`bulletin_${bulletin_id}_page_${current_page}`] = {
          loaded: false,
          loading: false,
          error: true,
        };
        break;

      case BulletinsTypes.FETCH_BULLETIN_CONTENT_REQUEST:
        draft.request.fetch_bulletin_content = {
          ...INITIAL_STATE.request.fetch_bulletin_content,
          loading: true,
        };
        break;

      case BulletinsTypes.FETCH_BULLETIN_CONTENT_SUCCESS:
        const updatedBulletinIndex = state.bulletins?.filter_bulletins?.findIndex(
          (filter_bulletin) => filter_bulletin.filter.id === filter_id,
        );

        if (updatedBulletinIndex === -1) return;
        if (!state.bulletins.filter_bulletins[updatedBulletinIndex]) return;

        const updatedFilterBulletins = _.uniq(
          [
            ...state.bulletins.filter_bulletins[updatedBulletinIndex].bulletin_filters,
            ...(result?.data?.data ? result.data.data : result.data),
          ],
          (item) => item.id,
        );

        draft.bulletins.filter_bulletins[updatedBulletinIndex].bulletin_filters =
          updatedFilterBulletins;

        draft.request.fetch_bulletin_content = {
          ...INITIAL_STATE.request.fetch_bulletin_content,
          loaded: true,
        };
        break;

      case BulletinsTypes.FETCH_BULLETIN_CONTENT_FAILURE:
        draft.request.fetch_bulletin_content = {
          ...INITIAL_STATE.request.fetch_bulletin_content,
          error: true,
        };
        break;

      case BulletinsTypes.FETCH_BULLETIN_CONTENT_BY_ID_REQUEST:
        draft.request.fetch_bulletin_content_by_id = {
          ...INITIAL_STATE.request.fetch_bulletin_content_by_id,
          loading: true,
        };
        break;

      case BulletinsTypes.FETCH_BULLETIN_CONTENT_BY_ID_SUCCESS:
        const updatedBulletinFilterByIdIndex = state.bulletins.filter_bulletins.findIndex(
          (filter_bulletin) => filter_bulletin.filter.id === result?.data[0].filter_id,
        );

        if (updatedBulletinFilterByIdIndex >= 0) {
          const updatedFilterBulletinsById = _.uniq(
            [
              ...state.bulletins.filter_bulletins[updatedBulletinFilterByIdIndex].bulletin_filters,
              ...(result?.data.data ? result.data.data : result.data),
            ],
            (item) => item.id,
          );

          draft.bulletins.filter_bulletins[updatedBulletinFilterByIdIndex].bulletin_filters =
            updatedFilterBulletinsById;
        }
        draft.request.fetch_bulletin_content_by_id = {
          ...INITIAL_STATE.request.fetch_bulletin_content_by_id,
          loaded: true,
        };
        break;

      case BulletinsTypes.FETCH_BULLETIN_CONTENT_BY_ID_FAILURE:
        draft.request.fetch_bulletin_content_by_id = {
          ...INITIAL_STATE.request.fetch_bulletin_content_by_id,
          error: true,
        };
        break;

      case BulletinsTypes.CREATE_VIEWED_BIDDING_REQUEST:
        draft.request.create_viewed_bidding_bulletin = {
          ...INITIAL_STATE.request.create_viewed_bidding_bulletin,
          loading: true,
        };
        break;

      case BulletinsTypes.CREATE_VIEWED_BIDDING_SUCCESS:
        draft.request.create_viewed_bidding_bulletin = {
          ...INITIAL_STATE.request.create_viewed_bidding_bulletin,
          loaded: true,
        };
        const createViewedBiddingIndex = state.bulletins.bulletins_biddings_list[
          bulletin_id
        ].biddings.findIndex((bidding) => Number(bidding.bidding_id) === Number(bidding_id));

        draft.bulletins.bulletins_biddings_list[bulletin_id].biddings[
          createViewedBiddingIndex
        ].viewed_by_user = true;
        draft.bulletins.bulletins_biddings_list[bulletin_id].biddings[
          createViewedBiddingIndex
        ].viewed_by = _.uniq([
          ...state.bulletins.bulletins_biddings_list[bulletin_id].biddings[createViewedBiddingIndex]
            .viewed_by,
          contact_name,
        ]);
        break;

      case BulletinsTypes.CREATE_VIEWED_BIDDING_FAILURE:
        draft.request.create_viewed_bidding_bulletin = {
          ...INITIAL_STATE.request.create_viewed_bidding_bulletin,
          error: true,
        };
        break;

      case BulletinsTypes.DESTROY_VIEWED_BIDDING_REQUEST:
        draft.request.destroy_viewed_bidding_bulletin = {
          ...INITIAL_STATE.request.destroy_viewed_bidding_bulletin,
          loading: true,
        };
        break;

      case BulletinsTypes.DESTROY_VIEWED_BIDDING_SUCCESS:
        draft.request.destroy_viewed_bidding_bulletin = {
          ...INITIAL_STATE.request.destroy_viewed_bidding_bulletin,
          loaded: true,
        };
        const destroyViewedBiddingIndex = state.bulletins.bulletins_biddings_list[
          bulletin_id
        ].biddings.findIndex((bidding) => Number(bidding.bidding_id) === Number(bidding_id));

        draft.bulletins.bulletins_biddings_list[bulletin_id].biddings[
          destroyViewedBiddingIndex
        ].viewed_by_user = false;
        draft.bulletins.bulletins_biddings_list[bulletin_id].biddings[
          destroyViewedBiddingIndex
        ].viewed_by = state.bulletins.bulletins_biddings_list[bulletin_id].biddings[
          destroyViewedBiddingIndex
        ].viewed_by.filter((contacts) => contacts !== contact_name);
        break;

      case BulletinsTypes.DESTROY_VIEWED_BIDDING_FAILURE:
        draft.request.destroy_bidding_favorite_bulletin = {
          ...INITIAL_STATE.request.destroy_bidding_favorite_bulletin,
          error: true,
        };
        break;

      case BulletinsTypes.MARK_ALL_BULLETINS_READ_REQUEST:
        draft.request.mark_all_bulletins_read = {
          ...INITIAL_STATE.request.mark_all_bulletins_read,
          loading: true,
        };
        break;

      case BulletinsTypes.MARK_ALL_BULLETINS_READ_SUCCESS:
        draft.request.mark_all_bulletins_read = {
          ...INITIAL_STATE.request.mark_all_bulletins_read,
          loaded: true,
        };
        break;

      case BulletinsTypes.MARK_ALL_BULLETINS_READ_FAILURE:
        draft.request.mark_all_bulletins_read = {
          ...INITIAL_STATE.request.mark_all_bulletins_read,
          error: true,
        };
        break;

      case BulletinsTypes.OVERVIEW_REQUEST:
        draft.request.overview = {
          ...INITIAL_STATE.request.overview,
          loading: true,
        };
        break;

      case BulletinsTypes.OVERVIEW_SUCCESS:
        draft.bulletins.total = result?.data?.total;
        draft.bulletins.by_region = result?.data?.by_region;
        draft.bulletins.by_esfera = result?.data?.by_esfera;
        draft.bulletins.by_modality = result?.data?.by_modality;
        draft.bulletins.by_situation = result?.data?.by_situation;
        draft.bulletins.by_portal = result?.data?.by_portal;
        draft.request.overview = {
          ...INITIAL_STATE.request.overview,
          loaded: true,
        };
        break;

      case BulletinsTypes.OVERVIEW_FAILURE:
        draft.request.overview = {
          ...INITIAL_STATE.request.overview,
          error: true,
        };
        break;

      case BulletinsTypes.INITIAL_STATE:
        draft.bulletins = INITIAL_STATE.bulletins;
        draft.comments_request = INITIAL_STATE.comments_request;
        draft.request = INITIAL_STATE.request;

        break;

      case BulletinsTypes.SEND_IA_MESSAGE_REQUEST:
        if (!draft.bulletins.ia_chat_messages) {
          draft.bulletins.ia_chat_messages = [...INITIAL_STATE.bulletins.ia_chat_messages];
        }
        draft.bulletins.ia_chat_messages.push({ role: 'user', content });
        draft.request.ia_chat = {
          ...INITIAL_STATE.request.ia_chat,
          loading: true,
        };
        break;

      case BulletinsTypes.SEND_IA_MESSAGE_SUCCESS:
        if (!draft.bulletins.ia_chat_messages) {
          draft.bulletins.ia_chat_messages = [...INITIAL_STATE.bulletins.ia_chat_messages];
        }
        draft.bulletins.ia_chat_messages.push({
          role: 'assistant',
          content: result.data.message,
        });
        if (result.data.tool) {
          const prevFilters = state.bulletins.ia_chat_tool_action?.filters;
          const newFilters = result.data.filters || {};

          draft.bulletins.ia_chat_tool_action = {
            tool: result.data.tool,
            name: result.data.name || '',
            filters: {
              objeto: newFilters.objeto || prevFilters?.objeto || '',
              notWord: newFilters.notWord || prevFilters?.notWord || '',
              states: newFilters.states?.length > 0 ? newFilters.states : prevFilters?.states || [],
              cities: newFilters.cities?.length > 0 ? newFilters.cities : prevFilters?.cities || [],
              validityStart: newFilters.validityStart || prevFilters?.validityStart || '',
              validityEnd: newFilters.validityEnd || prevFilters?.validityEnd || '',
              situations:
                newFilters.situations?.length > 0
                  ? newFilters.situations
                  : prevFilters?.situations || [],
              status: newFilters.status?.length > 0 ? newFilters.status : prevFilters?.status || [],
              orgao: newFilters.orgao || prevFilters?.orgao || '',
              esfera: newFilters.esfera?.length > 0 ? newFilters.esfera : prevFilters?.esfera || [],
              publicationStart: newFilters.publicationStart || prevFilters?.publicationStart || '',
              publicationEnd: newFilters.publicationEnd || prevFilters?.publicationEnd || '',
            },
          };
        }
        draft.request.ia_chat = {
          ...INITIAL_STATE.request.ia_chat,
          loaded: true,
        };
        break;

      case BulletinsTypes.SEND_IA_MESSAGE_FAILURE:
        draft.request.ia_chat = {
          ...INITIAL_STATE.request.ia_chat,
          error: true,
        };
        break;

      case BulletinsTypes.CLEAR_IA_MESSAGES:
        draft.bulletins.ia_chat_messages = [...INITIAL_STATE.bulletins.ia_chat_messages];
        draft.bulletins.ia_chat_tool_action = null;
        draft.request.ia_chat = { ...INITIAL_STATE.request.ia_chat };
        break;

      case BulletinsTypes.CLEAR_IA_TOOL_ACTION:
        draft.bulletins.ia_chat_tool_action = null;
        break;

      case BulletinsTypes.SET_IA_MESSAGES:
        draft.bulletins.ia_chat_messages = messages;
        break;

      case BulletinsTypes.SET_IA_APPLIED_FILTER:
        draft.bulletins.ia_applied_filter = iaAppliedFilter;
        break;

      case BulletinsTypes.CLEAR_IA_APPLIED_FILTER:
        draft.bulletins.ia_applied_filter = null;
        break;

      case BulletinsTypes.SET_STATUS_FILTER:
        draft.bulletins.status_filter = status_filter;
        break;

      case BulletinsTypes.SET_MATCH_ONLY_FILTER:
        draft.bulletins.match_only_filter = match_only_filter;
        break;

      default:
        break;
    }
  });
};

export default reducer;
